import { Box, CircularProgress, Typography, Button, Table, TableBody, TableCell, TableRow, Link, TableContainer } from '@mui/material';
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { fetchLists, deleteList, repopulate } from './listService';
import { Delete } from '@mui/icons-material';

function Lists() {
    const queryClient = useQueryClient();

    // Fetch user lists
    const { isLoading, error, data } = useQuery({
        queryKey: ['lists'],
        queryFn: () => fetchLists()
    });

    // Mutation for deleting a list
    const deleteMutation = useMutation(
        (listId) => deleteList(listId),
        {
            onSuccess: () => {
                queryClient.invalidateQueries({ queryKey: ['lists'] });
            }
        }
    );

    const navigate = useNavigate();

    const repopulateMutation = useMutation(
        (listId) => repopulate(listId),
        {
            onSuccess: (candidates, variables) => {
                queryClient.invalidateQueries({ queryKey: ['lists', variables] });
                navigate(`/lists/${variables}/swipe`)
            }
        }
    );

    if (isLoading) return <CircularProgress />;

    if (error) {
        console.error('Failed to fetch product lists:', error);
        return;
    }

    return (
        <Box>
            <TableContainer sx={{ overflowX: 'auto' }}>
                <Table>
                    <TableBody>
                        {
                            data.map((list, index) => (
                                <TableRow key={list.id}>
                                    <TableCell><Typography sx={{fontWeight: 600}} variant='h6'>{index + 1}</Typography></TableCell>
                                    <TableCell><Typography variant='h6'>{list.productCount} fa</Typography></TableCell>
                                    <TableCell><Typography>{list.name}</Typography></TableCell>
                                    <TableCell>
                                        <Link component={Button} onClick={() => repopulateMutation.mutate(list.id)} sx={{ fontWeight: 600 }}>
                                            Lista tovább szűkítése
                                        </Link>
                                    </TableCell>
                                    <TableCell>
                                        <Link component={RouterLink} to={`/lists/${list.id}`}>
                                            <Button variant="contained">Lista megnyitása</Button>
                                        </Link>
                                    </TableCell>
                                    <TableCell>
                                        <Button onClick={() => deleteMutation.mutate(list.id)} variant="contained" sx={{ bgcolor: "#575757" }}>
                                            <Delete />
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            ))
                        }
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
}

export default Lists;
